export default __webpack_public_path__ + "static/media/4.b81d53cf.jpg";